import dayjs from 'dayjs'

export default {
    transform(data) {
        return JSON.parse(data).reduce((dates, data) => {
            dates[dayjs(data.date).startOf('day').format()] = dates[dayjs(data.date).startOf('day').format()]
                ? [...dates[dayjs(data.date).startOf('day').format()], data]
                : [data]
            return dates
        }, {})
    },
}
